import {Team} from "/src/domain/challenges/ChallengeRegistrationData";
import React, {FunctionComponent, useMemo, useState} from "react";
import {ChallengeUser} from "/src/domain/challenges/ChallengeUser";
import {useTranslation} from "react-i18next";
import {Snackbar, Typography, Alert as MuiAlert, AlertProps} from "@mui/material";
import {copyToClipboard} from "/src/utils/copyToClipboard";
import makeStyles from "@mui/styles/makeStyles";
import cs from "classnames";
import {links} from "/src/domain/shared/links";


export type CurrentTeamProps = {
    teams: Team[],
    isTeamCreator: boolean,
    teamKey: string,
    currentUser: ChallengeUser,
    className?: string,
}

export const CurrentTeam: FunctionComponent<CurrentTeamProps> = ({
                                                                     teams,
                                                                     isTeamCreator,
                                                                     teamKey,
                                                                     currentUser,
                                                                     className
                                                                 }) => {
    const classes = useStyles();
    const currentTeam = useMemo(() => {
        return teams.find(t => {
            return t.participants.some(p => p.userId === currentUser.id);
        });
    }, [teams]);

    const {t} = useTranslation();
    const [isOpen, setOpen] = useState(false);

    if (!currentTeam) return null;

    const link = `${window.location.origin}/team?code=${teamKey}`;

    const handleCopy = () => {
        copyToClipboard(link);
        setOpen(true);
    };

    const handleClose = (event?: React.SyntheticEvent | Event, reason?: string) => {
        if (reason === 'clickaway') {
            return;
        }

        setOpen(false);
    };

    return (
        <div className={cs(classes.container, className)}>
            <br/>
            {isTeamCreator && <p>{t('teamCreatorInfo')}
                &nbsp; <strong onClick={handleCopy}
                               style={{cursor: "pointer"}}>{link}</strong><br/>{t('teamCreatorInfo2')}</p>}
            <br/>
            <Typography variant="subtitle1">{t('currentTeam')} {currentTeam.name}:</Typography>
            <ol>
                {currentTeam.participants.map(p => (
                    <li key={p.userId}>{(p.firstName?.trim() + ' ' + p.lastName?.trim()).trim()}</li>
                ))}
            </ol>

            <Snackbar open={isOpen} autoHideDuration={3000} onClose={handleClose}
                      anchorOrigin={{vertical: "top", horizontal: "center"}}>
                <MuiAlert elevation={6} variant="filled" onClose={handleClose} severity="success">
                    {t('copied')}
                </MuiAlert>
            </Snackbar>
        </div>
    );
}

const useStyles = makeStyles({
    container: {
        padding: "0 1.5rem",
    },
});